export const LOGOUT_REQUESTED_MESSAGE = 'logout-requested';
export const EID_LOGOUT_REQUESTED_MESSAGE = 'eid-logout-requested';

export const authBroadcastChannel = new BroadcastChannel('auth-channel');
